export default class PagingModel<T> {

    constructor(public totalPages: number, public items: T[], public currentPage: number) {
    }
}